import {
    Grid,
    GridProps,
    Heading,
    Text,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import React from 'react';
import BaseError from 'utils/base-error';
// eslint-disable-next-line no-restricted-imports
import { config } from 'shared/lib';
import { Button } from 'shared';

export type ErrorProps = {
    errors: BaseError[]
} & GridProps & React.RefAttributes<HTMLDivElement>

export const Error: React.FC<ErrorProps> = ({
    errors,
    ...props
}) => {
    const navigate = useNavigate();

    return (
        <Grid
            {...props}
            gap="2rem"
        >
            <Grid
                margin="auto"
                gap="2rem"
            >
                <Heading
                    textAlign="center"
                    fontSize="2rem"
                >
                    Страница временно недоступна
                </Heading>
                <Text
                    textAlign="center"
                    fontSize="1rem"
                >
                    Перезагрузите страницу или вернитесь сюда позже
                </Text>
                <Button
                    width="fit-content"
                    margin="auto"
                    onClick={() => navigate(-1)}
                >
                    Вернуться назад
                </Button>
                {config.env === 'dev' ? (
                    <Grid
                        width="50%"
                        margin="auto"
                        gap="1rem"
                    >
                        {errors.map(({ code, message }) => (
                            <Text>
                                [
                                {code}
                                ]
                                {' '}
                                {message}
                            </Text>
                        ))}
                    </Grid>
                ) : null}
            </Grid>
        </Grid>
    );
};
